import React, { useState, useEffect, useRef } from "react";
import Layout from "../Layout";
import axios from "axios";
import { Button, TextField } from "@mui/material";
import MaterialTable from "@material-table/core";
import SouthIcon from "@mui/icons-material/South";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

const Home = () => {
  const { workerCode } = useParams();
  const [worker, setWorker] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [positions, setPositions] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [startedOperations, setStartedOperations] = useState([]);
  const workerFieldRef = useRef(null);
  const documentNumberFieldRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (workerCode != null && workerCode !== "") {
      documentNumberFieldRef.current.focus();
    } else {
      workerFieldRef.current.focus();
    }

    if (workerCode != null && workerCode !== "") {
      setLoading(true);
      setWorker(workerCode);

      axios
        .get("http://83.144.125.123:5222/Document/GetPositionsForWorker", {
          params: {
            worker: workerCode,
            documentNumber: documentNumber,
          },
        })
        .then(function (response) {
          // Handle the response
          const positions = response.data;
          setPositions(positions); // Update the positions list in state
          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
          console.log(error?.response?.data);
          alert(
            "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Document/GetPositionsForWorker. Skontaktuj się z administratorem systemu. Komuniakt zwrotny: " +
              error?.response?.data
          );
        });

      axios
        .get("http://83.144.125.123:5222/Document/GetOperationsForWorker", {
          params: {
            worker: workerCode,
          },
        })
        .then(function (response) {
          // Handle the response
          const startedOperations = response.data;
          setStartedOperations(startedOperations); // Update the positions list in state
        })
        .catch(function (error) {
          console.log(error?.response?.data);
          alert(
            "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Document/GetOperationsForWorker. Skontaktuj się z administratorem systemu. Komuniakt zwrotny: " +
              error?.response?.data
          );
        });
    }
  }, []);

  const handleSubmit = (event) => {
    setLoading(true);
    event.preventDefault();
    setPositions([]);
    setStartedOperations([]);
    history.push("/" + worker);
    axios
      .get("http://83.144.125.123:5222/Document/GetPositionsForWorker", {
        params: {
          worker: worker,
          documentNumber: documentNumber,
        },
      })
      .then(function (response) {
        // Handle the response
        const positions = response.data;
        setPositions(positions); // Update the positions list in state
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error?.response?.data);
        alert(
          "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Document/GetPositionsForWorker. Skontaktuj się z administratorem systemu. Komuniakt zwrotny: " +
            error?.response?.data
        );
      });

    axios
      .get("http://83.144.125.123:5222/Document/GetOperationsForWorker", {
        params: {
          worker: worker,
        },
      })
      .then(function (response) {
        // Handle the response
        const startedOperations = response.data;
        setStartedOperations(startedOperations); // Update the positions list in state
      })
      .catch(function (error) {
        console.log(error?.response?.data);
        alert(
          "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Document/GetOperationsForWorker. Skontaktuj się z administratorem systemu. Komuniakt zwrotny: " +
            error?.response?.data
        );
      });
  };

  const options = {
    pageSize: -1,
    paging: false,
    search: false,
    rowStyle: (rowData) => {
      if (rowData.unitQuantity === 2) {
        return { backgroundColor: "#ff5050" };
      } else if (rowData.unitQuantity === 1) {
        return { backgroundColor: "#fafa50" };
      }
      return {};
    },
  };

  const handleRowClick = (event, rowData) => {
    console.log(rowData);
    history.push("/operations/" + rowData.originId + "/" + worker);
    history.go();
  };

  const handleRowStartedOperationsClick = (event, rowData) => {
    console.log(rowData);
    history.push(
      "/realization/" +
        rowData.originId +
        "/" +
        rowData.documentId +
        "/" +
        worker
    );
    history.go();
  };

  const goToHistory = () => {
    history.push("/operationshistory/" + worker);
    history.go();
  };

  return (
    <Layout>
      <div className="positions-container">
        {loading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            inputRef={workerFieldRef}
            type="text"
            label="Operator"
            id="worker"
            name="worker"
            value={worker}
            onChange={(event) => setWorker(event.target.value)}
            fullWidth="true"
          />
          <TextField
            inputRef={documentNumberFieldRef}
            type="text"
            label="Szukaj po: numer ZP, numer ZS, kod towaru, nazwa towaru, EAN"
            id="documentNumber"
            name="documentNumber"
            value={documentNumber}
            onChange={(event) => setDocumentNumber(event.target.value)}
            fullWidth="true"
            margin="normal"
          />
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Pokaż zlecenia
          </Button>
        </form>
        <br />
        <div className="info-label">
          Wybierz pozycję zlecenia do zrealizowania
          <SouthIcon />
        </div>
        <div className="datatable">
          <MaterialTable
            columns={[
              { title: "Dokument", field: "documentNumber" },
              {
                title: "Kod towaru",
                field: "code",
                cellStyle: (rowData) => ({
                  fontWeight: "bold",
                }),
              },
              { title: "Nazwa towaru", field: "name" },
              { title: "Ilość", field: "quantity" },
              {
                title: "Zrealizowano",
                field: "realized",
                cellStyle: (rowData) => ({
                  fontWeight: "bold",
                }),
              },
            ]}
            options={options}
            data={positions}
            onRowClick={handleRowClick}
            title="Zlecenia produkcyjne"
          />
        </div>
        <div className="datatable">
          <MaterialTable
            columns={[
              { title: "Dokument", field: "documentNumber" },
              { title: "Kod", field: "code" },
              { title: "Nazwa", field: "name" },
              { title: "Gniazdo", field: "documentNumber" },
              { title: "Ilość", field: "quantity" },
              {
                title: "Zrealizowano",
                field: "realized",
                cellStyle: (rowData) => ({
                  fontWeight: "bold",
                }),
              },
              {
                title: "Rozpoczęcie",
                field: "operationStart",
                cellStyle: (rowData) => {
                  return rowData.toString() !== "0001-01-01T00:00:00"
                    ? { backgroundColor: "#66de66" }
                    : null;
                },
                render: (rowData) => {
                  if (
                    rowData.operationStart.toString() !== "0001-01-01T00:00:00"
                  ) {
                    return new Date(rowData.operationStart).toLocaleString(
                      "pl-PL",
                      {
                        timeZone: "Europe/Warsaw",
                        hour12: false,
                      }
                    );
                  } else {
                    return "-";
                  }
                },
              },
              {
                title: "Pracownik",
                field: "worker",
                cellStyle: (rowData) => {
                  return rowData.toString() !== ""
                    ? { backgroundColor: "#66de66" }
                    : null;
                },
              },
            ]}
            options={options}
            data={startedOperations}
            onRowClick={handleRowStartedOperationsClick}
            title="Rozpoczęte przez operatora"
          />
        </div>
        <br />
        {worker && (
          <Button
            variant="contained"
            color="primary"
            onClick={goToHistory}
            fullWidth
          >
            Historia
          </Button>
        )}
      </div>
      <br />
      <small className="rightsText">
        © 2023 — Aplikacja{" "}
        <a
          href="https://www.center.pl/"
          target={"_blank"}
          className="clearLink"
        >
          Computer Center
        </a>
        . Wszelkie prawa zastrzeżone
      </small>
    </Layout>
  );
};

export default Home;
